module.exports = __webpack_public_path__ + "static/008627-97fe314307796fb56df2018f201b536d.jpg";